
import {
  upDataOper,
  addOper,
  getOperDetails,
  getAllRole,
  getCountryCodeList,
  getFindAreaList
} from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import uploadImage from "@/components/upload-image/upload-image.vue";
import downloadFile from "@/components/download-file/download-file.vue";
import showImg from "@/components/show-img/show-img.vue";
import addRuleInline from "../other/regular";
import i18n from "@/config/i18n";
import { listToTree } from "@/common/tree";
@Component({
  components: {
    "pi-upload-image": uploadImage,
    "download-file": downloadFile,
    "pi-show-img": showImg
  }
})
export default class ProjectconfigOperAdd extends Vue {
  private modalShow = false;
  private isQuery = false;
  private loading = false;
  private operRoleList: object[] = [];
  private FormData: objAny = {};

  private modalTitle = i18n.t("oper.add");
  private address = (rule: objAny, value: string, callback: Function) => {
    if (!value) {
      callback(new Error(i18n.t("oper.addressPl") + ""));
    } else {
      callback();
    }
  };
  private ruleInline: objAny = {
    ...addRuleInline,
    rolePkId: [
      { required: true, message: i18n.t("oper.rolePkIdPl"), trigger: "change" }
    ],
    tel: [{ required: true, validator: (rule: objAny, value: string, callback: any) {
      const reg =/^[0-9]{6,15}$/;
      if (!this.formItem.countryCode) {
          callback(new Error(i18n.t("pleaseSelect") + ""));
        } else if (value === "") {
          callback(new Error(i18n.t("regular.phone") + ""));
        } else if (!reg.test(value)) {
          callback(new Error(i18n.t("regular.tel") + ""));
        } else {
          callback();
        }
      
    }, trigger: "blur" }],
    address: [
      {
        required: true,
        validator: this.address,
        trigger: "blur"
      }
    ],
    areaPath: [
      {
        required: true,
        message: i18n.t("oper.addressPlCity"),
        trigger: "change"
      }
    ],
    expireTime: [
      {
        validator: this.timeRole,
        trigger: "change"
      }
    ]
  };
  public timeRole(rule: objAny, value: string, callback: Function) {
    if (this.timeAll) {
      callback();
    } else if (value == "") {
      callback(new Error(i18n.t("formText.selectTimePl") + ""));
    } else {
      callback();
    }
  }
  private formItem: objAny = {
    activeTime: "",
    expireTime: "",
    address: "",
    bindChargePileList: [],
    cityId: 0,
    cityName: "",
    companyName: "",
    contactPerson: "",
    description: "",
    operatorId: "",
    oprName: "",
    oprPkId: "",
    rolePkId: "",
    oprSystemLogo: "",
    oprSystemLogoFilePath: "",
    oprSystemLogoName: "",
    oprSystemName: "",
    areaPathList: [],
    areaPath: "",
    countryCode: "",
    tel: "",
    adminUserPkId: "",
    contactsMail: "",
    serviceTel: "",
    companyWebsite: "",
    androidAppDownloadLink: "",
    iosAppDownloadLink: ""
  };
  private type = "";
  private timeAll = false;
  private countryCodeList: object[] = [];
  async getCountryList(): Promise<void> {
    const ret = await getCountryCodeList({});
    if (ret.status === this.$config.apiStatus) {
      this.countryCodeList = ret.data || [];
    }
  }

  private areaChange = (val: [] = []) => {
    this.formItem.areaPath = val.join(",");
  };

  private areaList: object[] = [];
  async getAreaList(): Promise<void> {
    const ret = await getFindAreaList({});
    if (ret.status === this.$config.apiStatus) {
      let resData = ret.data || [];
      resData = resData.map(item => {
        return {
          value: item.pkid + "",
          label: item.name,
          pid: item.parentId + "",
          zipCode: item.zipCode
        };
      });
      this.areaList = listToTree(resData, { id: "value" });
    }
  }
  public open(item: objAny, type: string) {
    this.type = type;
    this.formItem.areaPathList = [];
    this.resetForm();
    this.getCountryList();
    this.getAllRole();
    this.getAreaList();
    this.$nextTick((): void => {
      this.FormData = this.$refs["formItem"];
      this.modalShow = true;
      if (type === "query") {
        this.isQuery = true;
      } else {
        this.isQuery = false;
      }
      if (type === "add") {
        this.modalTitle = i18n.t("oper.add");
        this.timeAll = false;
      } else {
        this.formItem.oprPkId = item.oprPkId;
        this.getOperDetails(item.oprPkId);
        this.modalTitle = this.isQuery
          ? i18n.t("oper.query")
          : i18n.t("oper.updata");
      }
    });
  }

  public resetForm() {
    this.handleReset();
    for (const i in this.formItem) {
      if (typeof this.formItem[i] !== "object") {
        this.formItem[i] = "";
      }
    }
  }
  public handleReset() {
    this.$nextTick(()=>{
      this.FormData.resetFields();
    })
  }
  public addrChange(data: objAny): void {
    this.formItem = Object.assign(this.formItem, data);
  }
  public uploadImg(data: objAny): void {
    if (data.key == "oprSystemLogoFilePath") {
      this.formItem.oprSystemLogoFilePath = data.filePath;
      this.formItem.oprSystemLogoName = data.fileName;
      this.formItem.oprSystemLogo = data.attachmentRecordPkId; //data.thumbnailFilePath;
    }
  }
  async handleSubmit(): Promise<void> {
    await this.formSubmit(this.FormData);
    const formItemTime: objAny = this.$refs.formItemTime;
    await this.formSubmit(formItemTime);

    this.submitData();
  }
  public formSubmit(name: objAny): Promise<[]> {
    return new Promise<[]>(resolve => {
      name.validate((valid: boolean): void => {
        if (valid) {
          resolve([]);
        }
      });
    });
  }

  public closeModal(): void {
    this.modalShow = false;
  }

  async submitData(): Promise<void> {
    let ret: objAny;
    const json = JSON.parse(JSON.stringify(this.formItem));
    json.activeTime = this.$common.userDate(json.activeTime, "yyyy-MM-dd");
    if (this.timeAll) {
      json.expireTime = "";
    } else {
      json.expireTime = this.$common.userDate(json.expireTime, "yyyy-MM-dd");
    }
    this.loading = true;
    if (this.formItem.oprPkId === "") {
      ret = await addOper(json);
    } else {
      ret = await upDataOper(json);
    }
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      const type: string = this.formItem.oprPkId === "" ? "new" : "";
      const item = ret.data[0] || {};
      this.$emit("success", item, type);
      this.modalShow = false;
    } else {
      this.modalShow = true;
    }
    this.loading = false;
  }

  async getOperDetails(oprPkId: string): Promise<void> {
    const ret = await getOperDetails({ oprPkId: oprPkId });
    if (ret.status === this.$config.apiStatus) {
      const data = ret.data[0];

      this.formItem.activeTime = "";
      this.formItem.expireTime = "";

      // 循环赋值
      for (const i in data) {
        const item = data[i];
        if (i == "activeTime" || i == "expireTime") {
          if (item && item != "") {
            this.formItem[i] = new Date(item);
          }
        } else if (this.formItem[i] !== undefined) {
          this.formItem[i] = item;
        }
      }
      this.formItem.countryCode = data.countryCode;
      this.formItem.areaPathList = data.areaPath?.split(",");

      this.formItem.oprSystemLogoFilePath = data.oprSystemLogoUrl
        ? this.$common.imgShowUrl(data.oprSystemLogoUrl)
        : "";

      if (this.formItem.expireTime == "") {
        this.timeAll = true;
      } else {
        this.timeAll = false;
      }
    }
  }
  async getAllRole(): Promise<void> {
    const ret = await getAllRole({});
    if (ret.status === this.$config.apiStatus) {
      this.operRoleList = (ret.data || []).filter(item => item.roleType == 2);
    }
  }
}
